var render, staticRenderFns
import script from "./renderColumn.vue?vue&type=script&lang=js"
export * from "./renderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12789b8f')) {
      api.createRecord('12789b8f', component.options)
    } else {
      api.reload('12789b8f', component.options)
    }
    
  }
}
component.options.__file = "src/vab/components/VabValidateTable/components/renderColumn.vue"
export default component.exports